import { render, staticRenderFns } from "./TopMenu.vue?vue&type=template&id=aba50ae8&scoped=true"
import script from "./TopMenu.vue?vue&type=script&lang=js"
export * from "./TopMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba50ae8",
  null
  
)

export default component.exports